module.exports = __webpack_public_path__ + "img/lock-white.7db1e8eb.svg";